// src/classes/class_1764437503691.js

const class_1764437503691 = 
  {
    id: 1764437503691,
    title: "Gourmet Cookies Online Workshop",
    date: "",
    details: `✔️ 6 Recipe Videos
✔️7+ Variations taught in class + PDF
✔️ Certificate
✔️ WhatsApp support 
Fees : 1299 only`,
    time: "",
    price: "Rs. 1299 /-",
    type: "online",
  }

export default class_1764437503691;
